"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webjs_sdk_1 = require("@aria/webjs-sdk");
const bew_localization_1 = require("@skype/bew-localization");
const react_1 = require("@stardust-ui/react");
const config_1 = require("config");
const React = require("react");
const ConfigContext_1 = require("src/ts/contexts/ConfigContext");
const EnvironmentHelper_1 = require("src/ts/helpers/EnvironmentHelper");
const LoggerHelper_1 = require("src/ts/helpers/LoggerHelper");
const UrlHelper_1 = require("src/ts/helpers/UrlHelper");
const MeetingContext_1 = require("../../../contexts/meetings/MeetingContext");
const StackNavigationContext_1 = require("../../../contexts/StackNavigationContext");
const UserContext_1 = require("../../../contexts/UserContext");
const GuestLogin_1 = require("./GuestLogin");
class UnifiedLoginMethod extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.renderDesktopBody = () => {
            if (EnvironmentHelper_1.deviceType !== EnvironmentHelper_1.DeviceTypes.Desktop) {
                return null;
            }
            return React.createElement(react_1.Text, { size: 'medium', className: 'text-body' },
                bew_localization_1.localizer.getString('Meetings.txt_join_meeting_description'),
                "\u00A0",
                React.createElement(react_1.Button, { key: 0, id: 'btnLaunchNow', onClick: this.props.onLaunchClick, className: 'fakeLink', "aria-label": `${bew_localization_1.localizer.getString('Meetings.txt_join_meeting_description')} ${bew_localization_1.localizer.getString('Meetings.lnk_join_meeting_retry')}`, text: true }, bew_localization_1.localizer.getString('Meetings.lnk_join_meeting_retry')));
        };
        this.renderDownloadButton = () => {
            return React.createElement(react_1.Button, { key: 1, id: 'btnDownload', text: true, onClick: this.downloadSkype }, bew_localization_1.localizer.getString('btn_launch_download_skype'));
        };
        this.downloadSkype = () => {
            LoggerHelper_1.logger.sessionFinished({ completionType: 'DownloadSkypeButton' }, webjs_sdk_1.AWTEventPriority.Immediate_sync);
            const downloadUrl = EnvironmentHelper_1.os === EnvironmentHelper_1.OperatingSystems.MacOS ? config_1.default.urls.app.downloadDesktop : config_1.default.urls.app.download;
            window.location.href = downloadUrl;
        };
        this._joinOnWebAsGuest = (stackNavigationContext) => {
            return () => {
                LoggerHelper_1.logger.action({ name: 'join-as-guest' });
                LoggerHelper_1.logger.sessionIntermediateStep({ eventType: 'JoinOnWebAsGuestInitialClickUnifiedView' });
                stackNavigationContext.push(React.createElement(GuestLogin_1.GuestLogin, null), { eventViewName: 'guest-login' });
            };
        };
        this._joinOnWebOtherAccount = (meetingContext) => {
            return () => {
                LoggerHelper_1.logger.action({ name: 'join-logout' });
                LoggerHelper_1.logger.sessionFinished({ completionType: 'JoinOnWebOtherAccount' }, webjs_sdk_1.AWTEventPriority.Immediate_sync);
                const webClientUrl = UrlHelper_1.UrlHelper.getWebClientUrl({ threadId: meetingContext.conversation.resource });
                window.location.href = config_1.default.urls.app.logout(webClientUrl, meetingContext.csrfToken);
            };
        };
        this._joinOnWeb = (meetingContext) => {
            return () => {
                LoggerHelper_1.logger.action({ name: 'join-login' });
                LoggerHelper_1.logger.sessionFinished({ completionType: 'JoinOnWeb' }, webjs_sdk_1.AWTEventPriority.Immediate_sync);
                window.location.assign(UrlHelper_1.UrlHelper.getWebClientUrl({ threadId: meetingContext.conversation.resource }));
            };
        };
    }
    render() {
        return React.createElement("div", { className: 'body' },
            this._renderTitle(),
            this._renderActions());
    }
    _renderTitle() {
        return React.createElement(UserContext_1.UserContextConsumer, null, (userContext) => React.createElement(react_1.Header, { as: 'h1', className: 'title' }, userContext.profile ?
            bew_localization_1.localizer.getString('Login.txt_sign_in_with_title')
            :
                bew_localization_1.localizer.getString('Meetings.txt_join_meeting_title')));
    }
    _renderActions() {
        return React.createElement(UserContext_1.UserContextConsumer, null, (userContext) => React.createElement("div", { className: 'actions-container' },
            React.createElement("div", { className: 'actions' }, userContext.profile ?
                this._renderAuthenticatedActions(userContext.profile) :
                this._renderUnauthenticatedActions()),
            this.renderDownloadButton(),
            this.renderDesktopBody()));
    }
    _renderAuthenticatedActions(userProfile) {
        return React.createElement(MeetingContext_1.MeetingContextConsumer, null, (meetingContext) => meetingContext &&
            React.createElement(React.Fragment, null,
                React.createElement(ConfigContext_1.ConfigContextConsumer, null, (configContext) => this._renderAccounts(userProfile, meetingContext, configContext)),
                this._renderWhatsThis()));
    }
    _renderAccounts(userProfile, meetingContext, configContext) {
        const email = userProfile.emails && userProfile.emails.length ?
            userProfile.emails[0] : undefined;
        const name = userProfile.firstname && userProfile.lastname ?
            `${userProfile.firstname} ${userProfile.lastname}` : userProfile.username;
        const avatarImage = {
            src: userProfile.avatarUrl || `${configContext.basePath}/images/avatar.jpg`,
            styles: { width: '100%', height: '100%', objectFit: 'cover' },
        };
        const currentAccountAvatar = React.createElement(react_1.Avatar, { styles: { margin: '10px 0px' }, size: 40, image: avatarImage });
        const currentAccountText = React.createElement(react_1.Layout, { vertical: true, start: React.createElement(react_1.Text, { size: 'small', weight: 'semibold' }, name), end: React.createElement(react_1.Text, { size: 'small' }, email) });
        const currentAccount = React.createElement(react_1.Button, { autoFocus: true, text: true, onClick: this._joinOnWeb(meetingContext) },
            React.createElement(react_1.Layout, { className: 'login-option', start: currentAccountAvatar, main: currentAccountText }));
        const otherAccountIcon = React.createElement(react_1.Icon, { name: 'add', size: 'large', styles: { backgroundColor: '#E5E4E8', borderRadius: '100%', margin: '10px 0px', color: 'white', padding: '10px' } });
        const otherAccountText = React.createElement(react_1.Layout, { vertical: true, start: React.createElement(react_1.Text, { size: 'small', weight: 'semibold' }, bew_localization_1.localizer.getString('Login.btn_use_other_account')) });
        const otherAccount = React.createElement(react_1.Button, { text: true, onClick: this._joinOnWebOtherAccount(meetingContext) },
            React.createElement(react_1.Layout, { className: 'login-option', start: otherAccountIcon, main: otherAccountText }));
        return React.createElement("div", { className: 'active' },
            React.createElement(react_1.Layout, { vertical: true, start: currentAccount, end: otherAccount }));
    }
    _renderUnauthenticatedActions() {
        return React.createElement(React.Fragment, null,
            React.createElement(StackNavigationContext_1.StackNavigationContextConsumer, null, (stackNavigationContext) => React.createElement(react_1.Button, { key: 0, id: 'btnJoinAsGuest', primary: true, autoFocus: true, onClick: this._joinOnWebAsGuest(stackNavigationContext) },
                React.createElement(react_1.Text, { weight: 'semibold' }, bew_localization_1.localizer.getString('Login.btn_join_as_guest')))),
            React.createElement(MeetingContext_1.MeetingContextConsumer, null, (meetingContext) => meetingContext &&
                React.createElement(React.Fragment, null,
                    React.createElement(react_1.Button, { key: 1, id: 'btnLogin', onClick: this._joinOnWeb(meetingContext) },
                        React.createElement(react_1.Text, { weight: 'semibold' }, bew_localization_1.localizer.getString('Login.btn_signin_create'))),
                    this._renderWhatsThis())));
    }
    _renderWhatsThis() {
        return React.createElement("span", { className: 'help' },
            bew_localization_1.localizer.getString('Login.txt_use_ms_account'),
            "\u00A0",
            React.createElement("a", { href: 'https://go.skype.com/help.password.faq.unifiedview', onClick: () => LoggerHelper_1.logger.action({ name: 'what-is-msa' }), target: '_blank', style: { color: '#0078d4' }, "aria-label": bew_localization_1.localizer.getString('Login.lnk_a11y_what_is_ms_account') }, bew_localization_1.localizer.getString('Login.lnk_what_is_ms_account')));
    }
}
exports.UnifiedLoginMethod = UnifiedLoginMethod;
